import React, { CSSProperties } from "react";
import { ModalNames } from "~/jsx/context/ModalNames";
import { transition } from "~/jsx/theme";
import { ZIndex } from "~/jsx/theme/ZIndex";
import { useModal } from "~/utils";

export const XModal = ({
  name,
  children,
  visible,
  style,
  contentStyle,
}: {
  name: ModalNames;
  children: React.ReactNode;
  visible?: boolean;
  style?: CSSProperties;
  contentStyle?: CSSProperties;
}) => {
  const { isModalVisible, hide, callbacks, dynamicContent } = useModal(name);
  const finalVisible = visible ?? isModalVisible;
  return (
    <div
      onClick={() => {
        callbacks?.onClose?.();
        hide();
      }}
      style={{
        width: "100%",
        height: "100%",
        position: "absolute",
        left: 0,
        top: 0,
        backgroundColor: "rgba(0, 0, 0, 0.3)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        opacity: finalVisible ? 1 : 0,
        transition: transition(),
        pointerEvents: finalVisible ? "auto" : "none",
        zIndex: ZIndex.modal,
        ...style,
      }}
    >
      <div
        style={{
          background: "white",
          borderRadius: 12,
          maxWidth: "100%",
          maxHeight: "100%",
          minWidth: 200,
          ...contentStyle,
        }}
        onClick={(event) => {
          event.stopPropagation();
        }}
      >
        {dynamicContent}
        {children}
      </div>
    </div>
  );
};
